import callApi from './backendService';
import { buildQueryUrlFromObject } from '../../helper/buildQueryUrlFromObject';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}`;

export const chat = (formData) => callApi({
  headers: {
      'Content-Type': 'multipart/form-data'
  },
  endpoint: `${basePath}/chat?${buildQueryUrlFromObject(formData)}`
});

export const chatById = (formData) => callApi({
  headers: {
      'Content-Type': 'multipart/form-data'
  },
  endpoint: `${basePath}/chat/${formData.member_uuid}?${buildQueryUrlFromObject(formData)}`
});

export const send = (data) => callApi({
  method: 'POST',
  endpoint: `${basePath}/chat`,
  body: data
});

export const saveImg = (formData) => callApi({
  method: 'POST',
  endpoint: `${basePath}/file/form-data/${process.env.VUE_APP_LINE_MESSAGE_CHANNEL_ID}/chat`,
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  body: formData
});

export const saveVideo = (formData) => callApi({
  method: 'POST',
  endpoint: `${basePath}/video/form-data/${process.env.VUE_APP_LINE_MESSAGE_CHANNEL_ID}/chat`,
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  body: formData
});

export const storeReservation = (storeInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/reservations`,
  body: storeInfo
});

export const templatesPush = (data) => callApi({
  method: 'POST',
  endpoint: `${basePath}/templates-push`,
  body: data
});

export const read = (member_uuid) => callApi({
  method: 'POST',
  endpoint: `${basePath}/read/${member_uuid}`
});

export const multicastSend = (data) => callApi({
  method: 'POST',
  endpoint: `${basePath}/multicast`,
  body: data
});

export const templatesMulticastPush = (data) => callApi({
  method: 'POST',
  endpoint: `${basePath}/templates-multicast`,
  body: data
});

export const invitationsPush = (data) => callApi({
  method: 'POST',
  endpoint: `${basePath}/invites`,
  body: data
});

export const invitationsMulticastPush = (data) => callApi({
  method: 'POST',
  endpoint: `${basePath}/invites-multicast`,
  body: data
});
export const getChatReadStatus = () => callApi({
  method: 'GET',
  endpoint: `${basePath}/chat/get-read-status`,
});

export const productsPush = (data) => callApi({
  method: 'POST',
  endpoint: `${basePath}/product`,
  body: data
});
export const productsMulticastPush = (data) => callApi({
  method: 'POST',
  endpoint: `${basePath}/product-multicast`,
  body: data
});

export const productsBuyPush = (data) => callApi({
  method: 'POST',
  endpoint: `${basePath}/regular-customer-product`,
  body: data
});
export const productsBuyMulticastPush = (data) => callApi({
  method: 'POST',
  endpoint: `${basePath}/regular-customer-product-multicast`,
  body: data
});
